import app from 'flarum/forum/app';
import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';

export default class InfoQuerySuccessModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
  }

  className() {
    return 'Modal--small';
  }

  title() {
    return app.translator.trans('ziven-u2di.lib.confirmation');
  }

  content() {
    return (
      <div className="Modal-body" style="padding-top: 0px;">
        <div className="Form" style="text-align:center">
          <div style="font-size: 16px;padding-bottom: 20px;">
            {app.translator.trans('ziven-u2di.forum.info-query-success')}
          </div>
          <div>
            {Button.component({
                className: 'Button Button--primary',
                disabled: this.loading,
                onclick: () => {
                  this.hide();
                }
              },
              app.translator.trans('ziven-u2di.lib.ok')
            )}
          </div>
        </div>
      </div>
    );
  }
}
